<template>
  <div class="mydialog big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="container">
      <div class="box">
        <div class="searchbox">
          <div class="item">
            <span>患者姓名</span>
            <el-input v-model="patient_name"
                      style="width: 110px; margin-left: 5px"
                      @input="search"
                      clearable></el-input>
          </div>
          <div class="item">
            <span>医生姓名</span>
            <el-input v-model="doctor_name"
                      style="width: 110px; margin-left: 5px"
                      @input="search"
                      clearable></el-input>
          </div>
          <div class="item">
            <span>所在省市</span>
            <el-select v-model="province_id"
                       placeholder="请选择"
                       @change="search"
                       style="width: 140px; margin-left: 5px"
                       clearable>
              <el-option v-for="item in proList"
                         :key="item.province_id"
                         :label="item.name"
                         :value="item.province_id"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>医生手机号</span>
            <el-input v-model="doctor_phone"
                      style="width: 110px; margin-left: 5px"
                      @input="search"
                      clearable></el-input>
          </div>

          <div class="item">
            <span>问诊类型</span>
            <el-select v-model="consult_type"
                       placeholder="请选择"
                       style="width: 170px; margin-left: 5px"
                       @change="search">
              <el-option v-for="item in consultTypeOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value"></el-option>
            </el-select>

          </div>

          <div class="item">
            <span>诊所名称</span>
            <el-input v-model="org_name"
                      style="width: 110px; margin-left: 5px"
                      @input="search"
                      clearable></el-input>
            <el-button type="info"
                       style="
                  background-color: #eceff2;
                  color: #747981;
                  margin-left: 20px;
                "
                       @click="search">查询</el-button>
          </div>
          <!-- <div class="item">
            <span>是否测试医生</span>
            <el-radio-group v-model="is_test"
                            @change="search"
                            style="margin-left: 5px">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </div> -->
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }">
            <el-table-column label="问诊发起时间/接诊时间"
                             width="260px">
              <template slot-scope="scope">
                <div>{{ scope.row.submit_time }}</div>
                <div v-if="scope.row.status != 2">
                  {{ scope.row.agree_time }}
                </div>
                <div v-if="scope.row.status == 2">---------</div>
              </template>
            </el-table-column>
            <el-table-column label="问诊费用"
                             prop="pay_money"></el-table-column>
            <el-table-column label="患者信息">
              <template slot-scope="scope">
                <div>{{ scope.row.real_name }}</div>
                <div>
                  <span v-if="scope.row.patient_sex == 1">男</span>
                  <span v-if="scope.row.patient_sex == 2">女</span>
                  <span v-if="scope.row.patient_sex == 0">未知</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="科室"
                             prop="department_name"></el-table-column>

            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div @click="showDocMsg(scope.row.doctor_id)"
                     style="cursor:pointer">{{ scope.row.doctor_name }}</div>
                <div>
                  <span v-if="scope.row.doctor_sex == 1">男</span>
                  <span v-if="scope.row.doctor_sex == 2">女</span>
                  <span v-if="!scope.row.doctor_sex">未知</span>
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>

            <el-table-column label="诊所名称"
                             prop="org_name"></el-table-column>
            <el-table-column prop="province_name"
                             label="所在省市"></el-table-column>

            <el-table-column label="咨询状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待提问</span>
                <span v-if="scope.row.status == 2">待确认</span>
                <span v-if="scope.row.status == 3">咨询中</span>
              </template>
            </el-table-column>
            <el-table-column label="问诊类型">
              <template slot-scope="scope">
                <span v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 1
                    ">患者问诊</span>
                <span v-if="scope.row.consult_type == 2">医生赠送</span>
                <span v-if="scope.row.consult_type == 3">诊后咨询</span>
                <span v-if="scope.row.consult_type == 4">预约视频</span>
                <span v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 2
                    ">视频问诊</span>
                <span v-if="
                      scope.row.consult_type == 1 &&
                      scope.row.consult_types == 3
                    ">电话问诊</span>
              </template>
            </el-table-column>
            <el-table-column label="操作"
                             width="200">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="toDetail(scope.row.consult_id, scope.row.consult_types)"
                           :disabled=" module_id_array[0]? !module_id_array.includes('1280'): false">查看记录</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin:20px 0"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tinycCinicManagement from '../../../api/tinycCinicManagement';
import platform from '../../../api/platform';
import _ from 'lodash';
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      patient_name: '',
      doctor_name: '',
      doctor_phone: '',
      consult_type: 0,
      province_id: '',
      org_name: '',
      proList: [],
      consultTypeOptions: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '患者问诊'
        },
        {
          value: 2,
          label: '医生赠送'
        },
        {
          value: 3,
          label: '诊后咨询'
        },
        {
          value: 4,
          label: '视频问诊'
        },
        {
          value: 5,
          label: '电话问诊'
        },
        {
          value: 6,
          label: '预约视频'
        }
      ],
      value: [],
      doc_msg: false,
      doctorId: ''
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  components: {
    DocMsg
  },
  created() {
    this.getProvince();
  },
  activated() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post('platform/platform/getProvinceCityDistrict')
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        consult_status: 1,
        over_type: this.value.length ? this.value.toString() : '0',
        consult_type: this.consult_type,
        province_id: this.province_id,
        org_name: this.org_name
      };
      tinycCinicManagement
        .consultList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.submit_time = item.submit_time
                ? platform.timestampToTime(item.submit_time)
                : '---------';
              item.agree_time = item.agree_time
                ? platform.timestampToTime(item.agree_time)
                : '---------';
              item.over_time = item.over_time
                ? platform.timestampToTime(item.over_time)
                : '';
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    toDetail(consult_id, consult_types) {
      this.$router.push({
        path: 'wenzhendetail',
        query: {
          consult_id,
          consult_types
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
.diaRefundbox {
  .info-box {
    height: 110px;
    padding: 10px 20px;
    margin: 0;
    p {
      margin: 0;
      padding: 0;
      font-size: 15px;
    }
    span {
      font-size: 15px;
    }
    .info-item {
      display: flex;
      justify-content: space-between;
    }
  }
  .align-center {
    margin: 10px 0 10px;
    .searchtitle {
      width: 80px;
      text-align: right;
    }
  }
}
</style>